import { useMemo } from "react";
import { useFormattedReference } from "@hooks/useFormattedReference";
import { REFERENCE_DATA_TYPES } from "@services/referenceDataApi";
import type { FromToLocation } from "@services/vessel-call/types";

export const useFromToLocationOptions = (locationFilter: (location: FromToLocation) => boolean) => {
  const { options: locations = [] } = useFormattedReference<FromToLocation>(
    REFERENCE_DATA_TYPES.FROM_TO_LOCATIONS,
    "bff-vessel-call",
  );
  const fromToLocationOptions = useMemo(
    () =>
      locations
        .filter(locationFilter)
        .filter(({ location }) => location !== "SEA")
        .map(({ fromToLocationCode, locationName }) => ({
          value: fromToLocationCode,
          label: locationName,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [locationFilter, locations],
  );

  return { locations, fromToLocationOptions };
};
